exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prebet-match__odd[data-v-fc0f9834]{background-color:var(--light-gray);color:var(--black);z-index:2;display:flex;flex-direction:row;justify-content:center;border-radius:15px;align-items:center;padding:8px 5px;border:none}.prebet-match__odd__odd-key[data-v-fc0f9834]{flex:4;text-align:left;font-size:var(--font-small);font-weight:var(--font-weight-normal);line-height:14px}.prebet-match__odd__odd-value[data-v-fc0f9834]{flex:1;font-size:var(--font-medium)}.prebet-match__odd.selected[data-v-fc0f9834]{background-color:var(--yellow);color:var(--always-black)}", ""]);

// exports
